import { css } from 'aphrodite';
import { ClockIcon } from '../../web/components/svgs/icons/ClockIcon';
import { CompactLogoIcon, ECompactLogoIconType } from '../../web/components/svgs/icons/CompactLogoIcon';
import { grayIconFill } from '../../web/styles/colors';
import { useMeeting } from '../contexts/meeting';
import { BookingTigerIcon } from '../icons/BookingTigerIcon';
import { styleSheet as pageStyles } from '../styles/styles';
import { getDurationText } from '../UiUtils';
import { styleSheet } from './styles';

export const ScheduleMeetingHeaderGroup = () => {
	const { meeting } = useMeeting();

	return (
		<header className={css(pageStyles.header, styleSheet.container)}>
			<figure className={css(styleSheet.iconContainer)}>
				{meeting?.accountType === 'Coffee' ? (
					<BookingTigerIcon />
				) : (
					<CompactLogoIcon type={ECompactLogoIconType.White} className={css(styleSheet.iconLevitateAccess)} />
				)}
			</figure>
			<div className={css(styleSheet.subText)}>Schedule a Meeting</div>
			<div className={css(styleSheet.titleText)}>{meeting?.title}</div>
			<div className={css(pageStyles.label, styleSheet.clockContainer)}>
				<ClockIcon className={css(styleSheet.clockIcon)} fillColor={grayIconFill} />
				{meeting?.duration ? getDurationText(meeting.duration) : ''}
			</div>
		</header>
	);
};
